import { PayeeAccountTypesEnum } from "@propertelligent/client-api";

/** Payee types that can receive a Plaid/online transfer on Settle Payables. */
const PLAID_CAPABLE_PAYEE_TYPES: ReadonlySet<number> = new Set([
  PayeeAccountTypesEnum.Propertelligent,
  PayeeAccountTypesEnum.Organization,
  PayeeAccountTypesEnum.Tenant,
  PayeeAccountTypesEnum.OrganizationUser,
  PayeeAccountTypesEnum.Contractor,
]);

/**
 * Whether Settle Payables may offer Plaid for this payee account type.
 * Bank Account / Vendor / Utility / etc. are not Plaid-capable.
 * Null/undefined → false. Propertelligent (0) is allowlisted (not treated as falsy).
 */
export function isPlaidCapablePayeeType(
  payeeAccountTypeId: number | null | undefined,
): boolean {
  if (payeeAccountTypeId === null || payeeAccountTypeId === undefined) {
    return false;
  }
  return PLAID_CAPABLE_PAYEE_TYPES.has(payeeAccountTypeId);
}
